import { Spinner } from 'flowbite-react';
import React, { useEffect, useState } from 'react';
import { Drawer } from '../shared/Drawer';

interface Props {
	showBenchMarkingRedirectionModal: boolean;
	setShowBenchMarkingRedirectionModal: (showBenchMarkingRedirectionModal: boolean) => void;
	handleSecondTestRedirect: () => void;
	isLoading: boolean;
}
const BenchMarkingRedirectionModal = ({
	showBenchMarkingRedirectionModal,
	setShowBenchMarkingRedirectionModal,
	handleSecondTestRedirect,
	isLoading,
}: Props) => {
	const [countdown, setCountdown] = useState(5);
	// as soon as this modal renders, start a 5 second countdown and do a redirect to the benchmark page
	useEffect(() => {
		const timer = setTimeout(() => {
			setCountdown(countdown - 1);
			if (countdown === 0) {
				handleSecondTestRedirect();
			}
		}, 1000);
		return () => clearTimeout(timer);
	}, [countdown]);
	return (
		<div>
			<Drawer
				header={<></>}
				backDropColor="#000000CC"
				modalMaxWidth="531px"
				closeButton={false}
				notCloseable={true}
				backgroundColor="transparaent"
				body={
					<div className="text-white flex flex-col items-center justify-center text-center">
						{isLoading && <Spinner />}
						{countdown > 0 && <p className="text-base mb-4">You will be redirected in {countdown} seconds</p>}
						{/* // */}
						<h1 className="text-xl font-[700]">
							AI interview complete. You will now be redirected to a 30-minute Rapid Evaluation.
						</h1>
					</div>
				}
				isOpen={showBenchMarkingRedirectionModal}
				isModal={true}
				onClose={(e, reason) => {
					if (reason !== 'backdropClick') {
						setShowBenchMarkingRedirectionModal(false);
					}
				}}
			/>
		</div>
	);
};

export default BenchMarkingRedirectionModal;
